export default {
  warrantyTitle: {
    id: 'plp_blocks_warranty_title',
    defaultMessage: 'Free 1-year warranty included',
  },
  warrantySubtitle: {
    id: 'plp_blocks_warranty_subtitle',
    defaultMessage: 'Device repair or replacement on us for all devices.',
  },
  expressReplacementTitle: {
    id: 'plp_blocks_express_replacement_title',
    defaultMessage: 'Express Replacement for free.',
  },
  expressReplacementSubtitle: {
    id: 'plp_blocks_express_replacement_subtitle',
    defaultMessage:
      'Not happy? We send you a replacement device before you send the original back.',
  },
  expressReplacementCta: {
    id: 'plp_blocks_express_replacement_cta',
    defaultMessage: 'See how',
  },
  telcoSingleTitle: {
    id: 'plp_blocks_telco_single_title',
    defaultMessage: 'Save up to €150 more on your smartphone with Bouygues',
  },
  telcoSingleCta: {
    id: 'plp_blocks_telco_single_cta',
    defaultMessage: 'Learn more',
  },
  telcoMultiTitle: {
    id: 'plp_blocks_telco_multi_title',
    defaultMessage: 'Call your mom, on a budget',
  },
  telcoMultiSubtitle: {
    id: 'plp_blocks_telco_multi_subtitle',
    defaultMessage:
      'Bundle your phone with a mobile plan at an exclusive price, only on Back Market.',
  },
  telcoMultiCta: {
    id: 'plp_blocks_telco_multi_cta',
    defaultMessage: 'Learn more',
  },
} as const
